export const MAX_TOTAL_BYTE_SIZE = 1_000_000_000;
export const MAX_VIDEO_DURATION = 7200;
export const MAX_FILE_COUNT = 5;
export const MAX_AVATAR_SIZE = 5_000_000;
export const BYTES_PER_MEGABYTE = 1024 * 1024;
export const SECONDS_PER_MINUTE = 60;
export const MIN_SCREEN_WIDTH = 600;
export const MAX_WEBSITE_SUB_LINKS = 500;
export const BF_PROMO_END_DATE = 1733202000000; // 2024-12-03 midnight EST
export const YOUTUBE_DEMO_VIDEO_ID = 'fEXOOcbqnp0';
export const NUM_BYTES_IN_MEGABYTE = 1_000_000;
export const MILLISECONDS_SECONDS_FACTOR = 1000;
